import { render, staticRenderFns } from "./ViewDenyUserForPublicRG.vue?vue&type=template&id=5942060a&scoped=true&"
import script from "./ViewDenyUserForPublicRG.vue?vue&type=script&lang=ts&"
export * from "./ViewDenyUserForPublicRG.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDenyUserForPublicRG.vue?vue&type=style&index=0&id=5942060a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942060a",
  null
  
)

export default component.exports